
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as indexrPuzFE_2WYtUjBNmQymy1YnH2fLgbD4w4nHUD68qrPoMeta } from "/app/pages/berlin/index.vue?macro=true";
import { default as index6UGwBVgJ7KAFRefzt6sAt7yvS9plwA_45bJkAHGw2LYPAMeta } from "/app/pages/brandenburg/index.vue?macro=true";
import { default as fotobox_45berlino63_AO2dxcPaR6lYofEeRKrk0T_2lmOYOGGPbgp3_45H0Meta } from "/app/pages/lp/fotobox-berlin.vue?macro=true";
import { default as erfolgreichZ5qtsFVz12NdMzHQseymtFXO4Y7c5p_45xqvZCga6GnGgMeta } from "/app/pages/anfrage/erfolgreich.vue?macro=true";
import { default as indexjIypmnL6zZ9kbIo4wMYQShZeFQ39gnmPdX_45lpmVPXIQMeta } from "/app/pages/berlin/[district]/index.vue?macro=true";
import { default as fotobox_45hochzeitoSaG7oH1uWGFmpkNQbQAZt7EtSzzwjLwN5x5E5DX_45C4Meta } from "/app/pages/berlin/fotobox-hochzeit.vue?macro=true";
import { default as indexRe0GXOwmPkVh6dZehakl7Ycy0Xvx9o9BC00LAos8LzAMeta } from "/app/pages/brandenburg/[district]/index.vue?macro=true";
import { default as _91eventType_9307IPhU5Wz68i0gfhIoU5ptoOCIO_pOw6I9egKEToIOwMeta } from "/app/pages/berlin/[district]/[eventType].vue?macro=true";
import { default as _91eventType_933u7ElwgztaelYuBN21s_mbYC_45a_H3b8MfjUlXpq74A0Meta } from "/app/pages/brandenburg/[district]/[eventType].vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "berlin",
    path: "/berlin",
    component: () => import("/app/pages/berlin/index.vue")
  },
  {
    name: "brandenburg",
    path: "/brandenburg",
    component: () => import("/app/pages/brandenburg/index.vue")
  },
  {
    name: "lp-fotobox-berlin",
    path: "/lp/fotobox-berlin",
    component: () => import("/app/pages/lp/fotobox-berlin.vue")
  },
  {
    name: "anfrage-erfolgreich",
    path: "/anfrage/erfolgreich",
    component: () => import("/app/pages/anfrage/erfolgreich.vue")
  },
  {
    name: "berlin-district",
    path: "/berlin/:district()",
    component: () => import("/app/pages/berlin/[district]/index.vue")
  },
  {
    name: "berlin-fotobox-hochzeit",
    path: "/berlin/fotobox-hochzeit",
    component: () => import("/app/pages/berlin/fotobox-hochzeit.vue")
  },
  {
    name: "brandenburg-district",
    path: "/brandenburg/:district()",
    component: () => import("/app/pages/brandenburg/[district]/index.vue")
  },
  {
    name: "berlin-district-eventType",
    path: "/berlin/:district()/:eventType()",
    component: () => import("/app/pages/berlin/[district]/[eventType].vue")
  },
  {
    name: "brandenburg-district-eventType",
    path: "/brandenburg/:district()/:eventType()",
    component: () => import("/app/pages/brandenburg/[district]/[eventType].vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]